import { render, staticRenderFns } from "./PlanningCardRightSidePanel.vue?vue&type=template&id=54601a18&scoped=true&"
import script from "./PlanningCardRightSidePanel.vue?vue&type=script&lang=ts&"
export * from "./PlanningCardRightSidePanel.vue?vue&type=script&lang=ts&"
import style0 from "./PlanningCardRightSidePanel.vue?vue&type=style&index=0&id=54601a18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54601a18",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VTextField})
